/* istanbul ignore file */
import { datadogLogs } from '@datadog/browser-logs';
import { STRINGS } from 'config';

export const initialiseDatadog = (): null => {
  if (STRINGS.ENVIRONMENT.IS_LOCAL) {
    return null;
  }
  datadogLogs.init({
    clientToken: STRINGS.DATADOG.ID,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: false,
    env: process.env.REACT_APP_ENVIRONMENT,
    service: `transcription-summariser-frontend:${process.env.REACT_APP_ENVIRONMENT}`,
  });
  datadogLogs.logger.setLevel('info');
  datadogLogs.setGlobalContextProperty(
    'transcription_summariser_frontend_version',
    process.env.REACT_APP_VERSION,
  );
  return null;
};

export const reportInfo = (info: string, details: unknown = {}): void => {
  datadogLogs.logger.info(info, {
    details,
    env: process.env.REACT_APP_ENVIRONMENT,
  });
};

export const reportError = (error: Error, info: unknown): void => {
  datadogLogs.logger.error('UNCAUGHT ERROR', {
    errorInfo: info,
    error: error.toString(),
    env: process.env.REACT_APP_ENVIRONMENT,
  });
};
